import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import HeroSection from './components/HeroSection';
import Footer from './components/Footer';
import LanguageSwitcher from '../../components/ui/LanguageSwitcher';
import { Helmet } from 'react-helmet';

const HomePage = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>SugarHathi — India's Digital Sugar Economy Platform</title>
        <meta name="description" content="SugarHathi connects sugar factories, quota holders, buyers, traders, and transporters across India. Trade sugar, track quota data, and access market intelligence." />
      </Helmet>
      {/* Navigation Header */}
      <header className="sticky top-0 z-50 w-full bg-[#0d1f35]/95 backdrop-blur-md border-b border-white/8">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
          <div className="flex h-16 items-center justify-between">
            {/* Brand */}
            <div className="flex items-center gap-3 cursor-pointer" onClick={() => navigate('/')}>
              <div className="w-12 h-12 rounded-xl overflow-hidden bg-white/10 flex-shrink-0 shadow-lg shadow-[#ff8c00]/20 border border-white/10">
                <img
                  src="/assets/images/ChatGPT_Image_Dec_1_2025_08_15_51_PM-1764613791088.png"
                  alt="SugarHathi logo"
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="min-w-0">
                <span className="text-xl font-black text-white tracking-tight truncate">SugarHathi</span>
                <span className="hidden sm:block text-[10px] text-slate-400 leading-none mt-0.5">India's Organised Sugar Economy</span>
              </div>
            </div>

            {/* Language + Sign In — visible at all breakpoints; hamburger handles menu */}
            <nav className="flex items-center gap-1 md:gap-2 min-w-0">
              <LanguageSwitcher tone="dark" />
              <button
                onClick={() => navigate('/login-authentication')}
                className="flex-shrink-0 px-2 py-1.5 md:px-4 md:py-2 text-xs md:text-sm font-medium text-slate-300 hover:text-white hover:bg-white/8 rounded-lg transition-all whitespace-nowrap"
              >
                Sign In
              </button>
            </nav>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden p-1.5 rounded-lg hover:bg-white/10 transition-colors text-white flex-shrink-0"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
            >
              <Icon name={isMenuOpen ? 'X' : 'Menu'} size={22} />
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="md:hidden absolute top-16 left-0 right-0 bg-[#0d1f35] border-b border-white/10 shadow-xl z-40">
              <nav className="flex flex-col p-4 space-y-1">
                {/* Mobile Language Switcher */}
                <div className="flex items-center mb-2">
                  <LanguageSwitcher tone="dark" />
                </div>
                <button
                  onClick={() => { setIsMenuOpen(false); navigate('/login-authentication'); }}
                  className="text-left text-sm font-medium text-slate-300 py-3 px-4 rounded-xl hover:bg-white/8 hover:text-white transition-all"
                >
                  Sign In
                </button>
              </nav>
            </div>
          )}
        </div>
      </header>
      <main>
        <HeroSection onGuestAction={() => navigate('/login-authentication')} />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;